import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from "@angular/core";
import {ApiService} from "../../../../../../../common/services/api.service";
import {Warehouse} from "../../../../../../../common/interfaces/warehouse.interface";
import {SpinnerService} from "../../../../../../../common/services/spinner.service";
import {Api3Service} from "../../../../../../../common/services/api3.service";
import {ToastService} from "../../../../../../../common/services/toast.service";
import {OrderWizardTransferDetailsComponent} from "../transfer-details/transfer-details.component";

@Component({
    selector: "section-order-wizard-kitting-details",
    templateUrl: "kitting-details.component.html",
    styleUrls: [
        "../transfer-details/transfer-details.component.scss",
        "kitting-details.component.scss"
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class OrderWizardKittingDetailsComponent extends OrderWizardTransferDetailsComponent
    implements OnDestroy, OnInit {


    public constructor(
        protected changeDetectorRef: ChangeDetectorRef,
        protected apiService: ApiService,
        protected api3Service: Api3Service,
        protected toastService: ToastService,
        protected spinnerService: SpinnerService,
    ) {
        super(changeDetectorRef, apiService, api3Service, toastService, spinnerService);
    }

    public async setFrom(group: { group_name: string, hubs: Warehouse.IHub[] }): Promise<any> {
        this.activeFrom = group.group_name;
        this.formGroup.get("origin_warehouse_id").setValue(group.hubs[0].warehouse.id);

        this.activeTo = group.group_name;
        this.formGroup.get("destination_warehouse_id").setValue(group.hubs[0].warehouse.id);

        const hubs_from: any = {};
        hubs_from[group.group_name] = group.hubs;

        const hubs_to: any = {};
        hubs_to[group.group_name] = group.hubs;

        this.result.next({
            action: "data",
            value: {hubs_from, hubs_to}
        });

        this.changeDetectorRef.markForCheck();
    }


    public ngOnInit(): void {
        super.ngOnInit();
    }

    public ngOnDestroy(): void {
        super.ngOnDestroy();
    }
}
